import { Link } from "react-router-dom";
import { categories, siteInfo } from "@/mocks/news";

const quickLinks = [
  { label: "今日速递", to: "/#feed" },
  { label: "事件时间线", to: "/#timeline" },
  { label: "热门人物", to: "/#figures" },
  { label: "快报专栏", to: "/category/briefs" },
  { label: "全部速递", to: "/category/all" },
  { label: "关于我们", to: "/about" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-950 text-secondary-100">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-chat-quote-fill text-lg text-background-50" />
              </span>
              <span className="font-heading text-xl font-black tracking-wide text-background-50">
                {siteInfo.name}
              </span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-secondary-300">
              独家黑料速递，今日新料实时更新。把散落的传闻、回应与时间点整理成可读的条目与完整时间线。
            </p>
            <p className="mt-4 text-xs leading-relaxed text-secondary-400">
              站内人物与事件均为虚构设定，用于演示资讯站的信息组织方式，不指向任何真实个人或机构。
            </p>
          </div>

          <div>
            <h4 className="label-font flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-accent-300">
              <i className="ri-compass-3-line" />
              站内导航
            </h4>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-secondary-200 transition-colors hover:text-accent-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="label-font flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-accent-300">
              <i className="ri-folder-open-line" />
              内容栏目
            </h4>
            <ul className="mt-4 space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-secondary-200 transition-colors hover:text-accent-300"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="label-font flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-accent-300">
              <i className="ri-mail-send-line" />
              联系我们
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-secondary-200">
              <li className="flex items-start gap-2.5">
                <span className="mt-0.5 flex h-4 w-4 items-center justify-center">
                  <i className="ri-mail-line text-accent-400" />
                </span>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-start gap-2.5">
                <span className="mt-0.5 flex h-4 w-4 items-center justify-center">
                  <i className="ri-time-line text-accent-400" />
                </span>
                <span>{siteInfo.replyTime}</span>
              </li>
              <li className="flex items-start gap-2.5">
                <span className="mt-0.5 flex h-4 w-4 items-center justify-center">
                  <i className="ri-refresh-line text-accent-400" />
                </span>
                <span>{siteInfo.updateNote}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-800 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-secondary-400">
            © 2026 {siteInfo.name} · 独家黑料速递与事件时间线梳理
          </p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-secondary-400">
            <Link to="/about" className="transition-colors hover:text-accent-300">
              内容原则
            </Link>
            <Link to="/#subscribe" className="transition-colors hover:text-accent-300">
              线索投递
            </Link>
            <Link to="/#faq" className="transition-colors hover:text-accent-300">
              常见问题
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}